import { z } from 'zod';

/** Global search (top bar): people, sites and vehicles the caller may open. */
export const SearchQuerySchema = z.object({
  q: z.string().trim().min(2).max(100),
});

export const SearchResultKindSchema = z.enum(['person', 'site', 'vehicle']);

export const SearchResultSchema = z.object({
  kind: SearchResultKindSchema,
  id: z.string(),
  /** Display name, site name or registration. */
  label: z.string(),
  /** One muted line: job and branch, region, make and model. */
  sub: z.string(),
  /** Where the result opens in the web app. */
  to: z.string(),
});

export const SearchResponseSchema = z.object({
  results: z.array(SearchResultSchema),
});

export type SearchResultKind = z.infer<typeof SearchResultKindSchema>;
export type SearchResult = z.infer<typeof SearchResultSchema>;
export type SearchResponse = z.infer<typeof SearchResponseSchema>;
